module.exports = __webpack_public_path__ + "static/media/loader.03bac207.gif";